import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-04024c20"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "success-box"
};
const _hoisted_2 = {
  key: 0,
  id: "successIcon",
  style: {
    "margin-top": "1rem"
  }
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  }
}, "已收到您的申请！", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_7 = {
  class: "icon",
  alt: "提交成功"
};
const _hoisted_8 = {
  key: 2,
  class: "button-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_buttom_com = _resolveComponent("buttom-com");
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.type == 'class1' ? (_openBlock(), _createElementBlock("p", _hoisted_2, [_hoisted_3, _hoisted_4, _createTextVNode("感谢您的认可与支持，我们的商务人员会第一时间与您取得联系！")])) : _createCommentVNode("", true), _ctx.type == 'class2' ? (_openBlock(), _createElementBlock("p", _hoisted_5, [_createTextVNode("感谢您的认可与支持，"), _hoisted_6, _createTextVNode("我们的安全专家会第一时间与您取得联系！")])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [[_directive_lazy, require('@/assets/img/success-icon.png')]]), !_ctx.isMobile && _ctx.type != 'class1' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_buttom_com, {
    btnName: "返回首页",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.toPage('/index.html')),
    filling: true
  })])) : _createCommentVNode("", true)]);
}